import { render } from "./manageEdit.vue?vue&type=template&id=ae38bbba&scoped=true"
import script from "./manageEdit.vue?vue&type=script&lang=js"
export * from "./manageEdit.vue?vue&type=script&lang=js"

import "./manageEdit.vue?vue&type=style&index=0&id=ae38bbba&lang=scss&scoped=true"
import "./manageEdit.vue?vue&type=style&index=1&id=ae38bbba&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae38bbba"]])

export default __exports__